import React from 'react'
// import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitThemeContent.module.scss";
import {RecruitTheme} from "./index"

const RecruitThemeContent = () => {
  // const breakpoints = useBreakpoint();
  const title1 = [
    { "id": 0, "text": "F" },
    { "id": 1, "text": "i" },
    { "id": 2, "text": "n" },
    { "id": 3, "text": "d" },
    { "id": 4, "text": "" },
    { "id": 5, "text": "Y" },
    { "id": 6, "text": "o" },
    { "id": 7, "text": "u" },
    { "id": 8, "text": "r" }
  ];
  const title3 = [
    { "id": 0, "text": "S" },
    { "id": 1, "text": "m" },
    { "id": 2, "text": "i" },
    { "id": 3, "text": "l" },
    { "id": 4, "text": "e" }
  ];
  const title4 = [
    { "id": 0, "text": "自" },
    { "id": 1, "text": "分" },
    { "id": 2, "text": "ら" },
    { "id": 3, "text": "し" },
    { "id": 4, "text": "く" },
    { "id": 5, "text": "働" },
    { "id": 6, "text": "け" },
    { "id": 7, "text": "る" },
    { "id": 8, "text": "場" },
    { "id": 9, "text": "所" },
    { "id": 10, "text": "へ" }
  ];
  return(
    <>
      <RecruitTheme className={`${styles.RecruitThemeContent__theme}`} data={title1}/>
      <RecruitTheme className={`${styles.RecruitThemeContent__theme}`} data={title3}/>
      <RecruitTheme className={`${styles.RecruitThemeContent__theme} ${styles.small}`} data={title4}/>
    </>
  )
}
export default RecruitThemeContent


